import React from 'react';

function MenuClosed() {
    return (
        <div className="alert alert-warning" role="alert">
            Vendor is closed today.
        </div>
    )
}

export default MenuClosed;